import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './translation.ja';

i18n.use(initReactI18next).init({
  lng: 'ja',
  debug: true,
  resources: {
    ja: {
      translation: ja,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
